import { qiniuInfo, areaList } from '@/api/common'

import { SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from './mutationTypes'
// 获取七牛信息

export const getUrlAndTokenOfImageUpload = async({ commit }) => {
    const response = await qiniuInfo()
    commit(SET_BUCKET_DOMAIN, response.data.BucketDomain)
    commit(SET_BUCKET_DOMAIN_TOKEN, response.data.token)
}

export const getAreaInfo = ({ commit, state }) => {
    return new Promise(async(resolve, reject) => {
        if (state.areaList.length) {
            resolve()
        } else {
            const data = await areaList().catch(error => {
                reject(error)
            })
            const flatData = flatArray(data)
            commit('SET_CODE_TEXT', flatData)
            commit('SET_AREA_LIST', data)
        }
    })
}

function flatArray(data, CodeToText = {}) {
    for (const item in data) {
    // console.log(item)
        CodeToText[data[item].code] = data[item].fullname
        if (data[item].children) {
            flatArray(data[item].children, CodeToText)
        }
    }
    return CodeToText
}

export const addKeepAlive = ({ commit, state }, val) => {
    const list = val instanceof Array
        ? [...new Set([...state.keepAliveComponents, ...val])]
        : [...new Set([...state.keepAliveComponents, val])]
    commit('setKeepAlive', list)
}

export const removeKeepAlive = ({ commit, state }, val) => {
    const list = state.keepAliveComponents.filter(i => i !== val)
    commit('setKeepAlive', list)
}

